import {
  HttpGetRequest,
  HttpPostRequest,
  HttpPutRequest,
} from "./HttpRequest.js";

export async function create(careUnit) {
  let url = "/care_unit";
  return await HttpPostRequest(url, careUnit).then((response) => {
    return response.json();
  });
}

export async function update(id, careUnit) {
  let url = "/care_unit/" + id;
  return await HttpPutRequest(url, careUnit).then((response) => {
    return response.json();
  });
}

export async function getOne(careUnitId) {
  let url = "/care_unit/" + careUnitId;
  return await HttpGetRequest(url).then((response) => {
    return response.json();
  });
}

export async function all(payload) {
  let url = "/care_units";
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}
